import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export function TextLoading({ className }: { className?: string }) {
  const { t } = useTranslation();

  // TODO: consider aria of loading animation... seems like an unclear answer is out there
  return (
    <span
      className={twMerge(
        "inline-block w-[16ch] scale-y-90 rounded-sm bg-black/10 text-transparent animate-pulse select-none animate-duration-2000",
        className,
      )}
      role="presentation"
    >
      {t("loading")}
    </span>
  );
}
